import PubSub from 'pubsub-js';

import topics from 'js/topics.json';

function onTopic(topic, func) {
  if (typeof func !== 'function') return;

  return PubSub.subscribe(topic, (topic, { message, title }) => {
    func({ message, title });
  });
}

function send(topic, payload = {}) {
  PubSub.publish(topic, payload);
}

const onErrorMessage = func => onTopic(topics.errorMessage, func);

function off(token) {
  if (!token) {
    return;
  }

  PubSub.unsubscribe(token);
}

const onMessage = func => onTopic(topics.message, func);

const onHideMessage = func => onTopic(topics.hideMessage, func);

const hideMessage = () => send(topics.hideMessage);

const sendErrorMessage = ({ message, title }) =>
  send(topics.errorMessage, { message, title });

const sendMessage = ({ message, title }) =>
  send(topics.message, { message, title });

export default {
  onErrorMessage,
  off,
  onMessage,
  hideMessage,
  onHideMessage,
  sendErrorMessage,
  sendMessage
};
